export type PathVariableMapping = Record<string, string | number>;

export function replacePathVariables(
  path: string,
  variables: PathVariableMapping,
): string {
  return Object.keys(variables).reduce((currentPath, variable) => {
    const pathVariable = `:${variable}`;
    const value = variables[variable];
    const newPath = currentPath.replace(pathVariable, String(value));

    if (newPath === currentPath) {
      throw new Error(
        `Error replacing variable in path "${path}".  Could not find pattern "${pathVariable}"`,
      );
    }

    return newPath;
  }, path);
}
